<template>
  <div class="picker__wrp">
    <date-picker
      :placeholder="placeholder"
      :value="value"
      :format="format"
      :value-type="valueType"
      title-format="DD.MM.YYYY"
      :confirm="showButtons"
      :clearable="false"
      :range="range"
      :disabled="disabled"
      :open.sync="isOpen"
      :default-value="defaultValue"
      class="bim-datepicker"
      :class="{ error__form: observableError }"
      :popup-class="[popupClass, 'bim-popup-datepicker', !showButtons ? 'none-buttons' : '']"
      @input="onInputValueChanged"
      :lang="lang"
      v-bind="$attrs"
      :range-separator="rangeSeparator"
    >
      <div slot="icon-calendar">
        <div v-html="require('@/assets/img/calendar.svg')"></div>
      </div>
      <template v-slot:footer v-if="showButtons">
        <bim-button
          label="Отменить"
          size="l"
          width="132"
          color="gray"
          @click="close"
          class="mr-6"
        />
        <bim-button label="Подтвердить" size="l" width="132" @click="clickToConfirm" />
      </template>
    </date-picker>

    <bimErrorField :error="observableError" />
  </div>
</template>

<script>
// https://github.com/mengxiong10/vue2-datepicker
import DatePicker from 'vue2-datepicker'
import bimButton from '../bimButton/bimButton'
import 'vue2-datepicker/index.css'

import localeEN from '@/components/core/bimCalendar/locale/en'
import localeRU from '@/components/core/bimCalendar/locale/ru'

const langEnum = {
  ru: localeRU,
  en: localeEN,
}

import ValidationFormMixin from '@/utils/validate2/validation-form-mixin'
import bimErrorField from '@/components/form/bimErrorField/bimErrorField'

export default {
  name: 'bimDatepick',
  mixins: [ValidationFormMixin],
  components: { DatePicker, bimButton, bimErrorField },
  props: {
    /**
     * Дополнителный класс для попапа датапикера
     */
    popupClass: {
      type: String,
      default: '',
    },
    /**
     * Формат даты который отображается в поле инпута. Подробнее тут https://github.com/mengxiong10/vue2-datepicker#token
     */
    format: {
      type: String,
    },
    /**
     * Формат даты который получим на выходе. Подробнее тут https://github.com/mengxiong10/vue2-datepicker#value-type
     */
    valueType: {
      type: String,
      default: 'date',
    },
    /**
     * Если true - делает диапазон даты
     */
    range: {
      type: Boolean,
      default: false,
    },
    /**
     * Разделитель в диапазоне дат
     */
    rangeSeparator: {
      type: String,
      default: '~',
    },
    /**
     * Значение поля по умолчанию
     */
    defaultValue: {
      type: [Date, String, Array],
      default () {
        const today = new Date()

        if (this.range) {
          const lastMonth = new Date()
          lastMonth.setMonth(today.getMonth - 1)
          return [lastMonth, today]
        }

        return today
      },
    },
    /**
     * Значение placeholder
     */
    placeholder: {
      type: String,
      default: 'Выберите дату',
    },
    /**
     * Отключение поля
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Принимает пустое поле или дату. На всякий случай строку
     * @model
     */
    value: {
      type: [String, Date, Number, Array],
      default: ''
    },
    /**
     * Показывать кнопки подтверждения внизу
     */
    showButtons: {
      type: Boolean,
      default: true
    },
    language: {
      type: String,
      default: 'ru'
    }
  },
  data () {
    return {
      isOpen: false,
      lang: {
        monthFormat: 'MMMM',
      },
    }
  },
  watch: {
    language (lang) {
      this.changeLang(lang)
    }
  },
  created () {
    this.changeLang(this.language)
  },
  methods: {
    clickToConfirm () {
      const btn = document.querySelector('.mx-datepicker-btn-confirm')
      btn.style.display = 'none'
      btn.click()
    },
    onInputValueChanged (value) {
      this.$emit('input', value)
    },
    close () {
      this.isOpen = false
      this.$emit('blur')
    },
    changeLang (lang) {
      this.lang = langEnum[lang]
    }
  },
}
</script>

<style lang="scss">
  .asg {
    color: #000;
  }
</style>
